export * from '@routr/shared'
import { CATEGORY_META as META, groupMeta as sharedGroupMeta, type DeviceCategory, type ListGroup } from '@routr/shared'
import type { IconName } from '@/components/ui/Icon'

/** The shared vocabulary types icons as strings; the client knows its icon set. */
type Meta = Omit<(typeof META)[DeviceCategory], 'icon'> & { icon: IconName }
export const CATEGORY_META = META as Record<DeviceCategory, Meta>
export const groupMeta = (group: ListGroup): Meta => sharedGroupMeta(group) as Meta
